// extracted by mini-css-extract-plugin
export default {"container":"DataKeyValue_container__a7ZQM","key":"DataKeyValue_key__VJQ8X","value":"DataKeyValue_value__FnOpA"};